module.exports = __webpack_public_path__ + "img/companyicon.0cced923.png";